import {
  PartnershipsSection,
  StaticPartnershipsSectionProps,
} from '~/features/experiments/ab_plp_redesign_2025/components/partnerships-section';
import { UdacityTopProgramsSection } from '~/features/experiments/ab_plp_redesign_2025/components/udacity-top-programs-section';
import { ThirdPartyReviewContentList } from '~/features/third-party-reviews/model';

import { PlansBusinessBannerSection } from './plans-business-banner-section';
import { PlansComparisonSection } from './plans-comparison-section';
import { PlansFooterBannerSection } from './plans-footer-banner-section';
import { PlansPricingHeroSection } from './plans-pricing-hero-section';
import { PlansSocialProofSection } from './plans-social-proof-section';
import { PlansStatsFaqSection } from './plans-stats-faq-section';

export function PlansPage({
  partnershipsSectionProps,
  thirdPartyReviews,
}: {
  partnershipsSectionProps: StaticPartnershipsSectionProps;
  thirdPartyReviews: ThirdPartyReviewContentList;
}) {
  return (
    <>
      <PlansPricingHeroSection />
      <PlansComparisonSection />
      <PlansBusinessBannerSection />
      <UdacityTopProgramsSection analyticsAction='plans_ndcard_clicked' analyticsEventName='Plans CTA Clicked' />
      <PartnershipsSection {...partnershipsSectionProps} />
      <PlansSocialProofSection thirdPartyReviews={thirdPartyReviews} />
      <PlansStatsFaqSection />
      <PlansFooterBannerSection />
    </>
  );
}
